import { motion } from "framer-motion";
import { Play, Pause, ChevronDown, Leaf } from "lucide-react";
import { ASSETS } from "@/data";
import { useAudio } from "@/context/AudioContext";

export const Hero = () => {
  const { playing, toggle } = useAudio();

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${ASSETS.hero})` }}
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full pt-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <span className="inline-flex items-center gap-2 eyebrow !text-brand-goldLight">
            <Leaf size={14} /> Praktijk Freedom Serenity
          </span>
          <h1 className="font-display text-white text-6xl sm:text-7xl lg:text-8xl leading-[0.92] mt-5">
            Freedom<br />Serenity
          </h1>
          <p className="font-script text-brand-goldLight text-5xl sm:text-6xl leading-none mt-2">
            Thuiskomen in jezelf
          </p>

          <div className="mt-8 space-y-1.5 text-white/90 font-body text-lg sm:text-xl">
            <p>Van spanning naar rust.</p>
            <p>Van overleven naar verbinding.</p>
            <p>Van denken naar voelen.</p>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#workshops"
              data-testid="hero-discover-button"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-brand-sage text-white font-body tracking-[0.12em] text-sm uppercase transition-all hover:bg-brand-forest hover:scale-[1.02] shadow-lg"
            >
              <Leaf size={16} /> Ontdek de workshops
            </a>
            <button
              onClick={toggle}
              data-testid="hero-song-button"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-white/15 border border-white/50 text-white font-body tracking-[0.12em] text-sm uppercase transition-all hover:bg-white/25 backdrop-blur-sm"
            >
              <span className="grid place-items-center w-7 h-7 rounded-full bg-white text-brand-forest">
                {playing ? <Pause size={13} /> : <Play size={13} className="ml-0.5" />}
              </span>
              Luister naar ons lied
            </button>
          </div>
        </motion.div>
      </div>

      <a
        href="#over-ons"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/80 animate-bounce"
        aria-label="Scroll omlaag"
      >
        <span className="grid place-items-center w-10 h-10 rounded-full border border-white/40">
          <ChevronDown size={20} />
        </span>
      </a>
    </section>
  );
};
